import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

import ContactUs from '../contactUs/ContactUs';
import './AlmostThere.scss';

const AlmostThere: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='login'>
      <Helmet>
        <title>{t('almostThere_title')}</title>
      </Helmet>
      <div className='text-center almost-there pt-4'>
        <h2>{t('almostThere_heading')}</h2>
        <div>{t('almostThere_description')}</div>
        <div className='contact-us-wrapper py-3 mx-auto my-2 text-center'>
          <ContactUs />
        </div>
      </div>
    </div>
  );
};

export default AlmostThere;
